
import { ContentLoader } from "vue-content-loader";
export default {
	components: { ContentLoader },
};
